import createNetworkingClient from 'utils/networking-client';

export const types = {
  SET_DURATION: 'SET_DURATION',
  ADYEN_PRODUCT_CHECKOUT_REQUEST: 'ADYEN_PRODUCT_CHECKOUT_REQUEST',
  ADYEN_PRODUCT_CHECKOUT_SUCCESS: 'ADYEN_PRODUCT_CHECKOUT_SUCCESS',
  ADYEN_PRODUCT_CHECKOUT_FAILURE: 'ADYEN_PRODUCT_CHECKOUT_FAILURE',
  CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR: 'CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR',
  CHECK_PROMO_CODE_REQUEST: 'CHECK_PROMO_CODE_REQUEST',
  CHECK_PROMO_CODE_SUCCESS: 'CHECK_PROMO_CODE_SUCCESS',
  CHECK_PROMO_CODE_FAILURE: 'CHECK_PROMO_CODE_FAILURE',
  REMOVE_PROMO_CODE_REQUEST: 'REMOVE_PROMO_CODE_REQUEST',
  REMOVE_PROMO_CODE_SUCCESS: 'REMOVE_PROMO_CODE_SUCCESS',
  REMOVE_PROMO_CODE_FAILURE: 'REMOVE_PROMO_CODE_FAILURE',
  TOGGLE_PROMO_CODE_INPUT_VISIBILITY: 'TOGGLE_PROMO_CODE_INPUT_VISIBILITY'
};

export const setYearlyDuration = () => ({
  type: types.SET_DURATION,
  duration: 'yearly'
});

export const setMonthlyDuration = () => ({
  type: types.SET_DURATION,
  duration: 'monthly'
});

const postAdyenProductCheckoutRequest = () => ({
  type: types.ADYEN_PRODUCT_CHECKOUT_REQUEST
});

const postAdyenProductCheckoutSuccess = () => ({
  type: types.ADYEN_PRODUCT_CHECKOUT_SUCCESS
});

const postAdyenProductCheckoutFailure = () => ({
  type: types.ADYEN_PRODUCT_CHECKOUT_FAILURE
});

export const clearCheckoutError = () => ({
  type: types.CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR
});

export const postAdyenProductCheckout = (postData) => (dispatch) => {
  dispatch(postAdyenProductCheckoutRequest());

  const instance = createNetworkingClient({ timeout: 30000 });
  return instance
    .post('/adyen/api_product_checkout', { ...postData })
    .then((response) => {
      if (response && response.data.success) {
        dispatch(postAdyenProductCheckoutSuccess());
      } else {
        dispatch(postAdyenProductCheckoutFailure());
      }
    })
    .catch(() => {
      dispatch(postAdyenProductCheckoutFailure());
    });
};

export const postAdyenTrialCheckout = (postData) => (dispatch) => {
  dispatch(postAdyenProductCheckoutRequest());

  const instance = createNetworkingClient({ timeout: 30000 });
  return instance
    .post('/adyen/api_product_trial_checkout', { ...postData })
    .then((response) => {
      if (response && response.data.success) {
        dispatch(postAdyenProductCheckoutSuccess());
      } else {
        dispatch(postAdyenProductCheckoutFailure());
      }
    })
    .catch(() => {
      dispatch(postAdyenProductCheckoutFailure());
    });
};

const postCheckPromoCodeRequest = () => ({
  type: types.CHECK_PROMO_CODE_REQUEST
});

const postCheckPromoCodeSuccess = (data) => ({
  type: types.CHECK_PROMO_CODE_SUCCESS,
  payload: data
});

const postCheckPromoCodeFailure = () => ({
  type: types.CHECK_PROMO_CODE_FAILURE
});

export const postCheckPromoCode = (postData) => (dispatch) => {
  dispatch(postCheckPromoCodeRequest());

  return createNetworkingClient({ timeout: 300000 })
    .post('/premium/check_promo', { ...postData })
    .then((response) => {
      if (response && response.data.success) {
        dispatch(postCheckPromoCodeSuccess(response.data));
      } else {
        dispatch(postCheckPromoCodeFailure());
      }
    })
    .catch(() => {
      dispatch(postCheckPromoCodeFailure());
    });
};

const postRemovePromoCodeRequest = () => ({
  type: types.REMOVE_PROMO_CODE_REQUEST
});

const postRemovePromoCodeSuccess = (data) => ({
  type: types.REMOVE_PROMO_CODE_SUCCESS,
  payload: data
});

const postRemovePromoCodeFailure = () => ({
  type: types.REMOVE_PROMO_CODE_FAILURE
});

export const togglePromoCodeInputVisibility = () => ({
  type: types.TOGGLE_PROMO_CODE_INPUT_VISIBILITY
});

export const postRemovePromoCode = (postData) => (dispatch) => {
  dispatch(postRemovePromoCodeRequest());

  return createNetworkingClient({ timeout: 300000 })
    .post('/premium/remove_promo', { ...postData })
    .then((response) => {
      if (response && response.data.success) {
        dispatch(postRemovePromoCodeSuccess(response.data));
      } else {
        dispatch(postRemovePromoCodeFailure());
      }
    })
    .catch(() => {
      dispatch(postRemovePromoCodeFailure());
    });
};

export default {
  types,
  setYearlyDuration,
  setMonthlyDuration,
  postAdyenProductCheckout,
  postAdyenTrialCheckout,
  togglePromoCodeInputVisibility
};
